define('presentation/common/routeToModal/viewModels/routeToCallQueueViewModel',['common/promises/promiseFactory',
    'businessServices/events/eventManager',
    'businessServices/state/modelStateObserver',
    'common/collections/collectionSorter',
    'constants/autoAttendantVoiceRouteEnumerations',
    'presentation/common/routeToModal/facades/routeToCallQueueFacade'
], function() {

    return function(initialRoutedToId, initialRouteToType, nameThisOption, routingRuleExitConditions, validateRouteToViewModelCallback) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const SorterConstructor = require('common/collections/collectionSorter');
        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

        const _eventManager = require('businessServices/events/eventManager');
        const _voiceRouteEnumerations = require('constants/autoAttendantVoiceRouteEnumerations');
        const _i18n = require('i18next');

        const _promiseFactory = new PromiseFactoryConstructor();

        let _disposables = [];
        let _facade = null;

        const onSelectedCallQueueChanged = () => {
            self.isValid(!!self.selectedCallQueue());
            validateRouteToViewModelCallback({});
        };

        self.modelStateObserver = new ModelStateObserverConstructor(self, true);
        self.selectedCallQueue = ko.observable().extend({observeState: true});
        _disposables.push(self.selectedCallQueue.subscribe(onSelectedCallQueueChanged));
        self.routeToStrategy = null;
        self.isNewRouteTo = true;
        self.isValid = ko.observable(false);
        self.availableCallQueues = ko.observable([]);
        self.placeholderMessage = _i18n.t('routeToCallQueue:selectCallQueue');

        self.callQueues = ko.pureComputed(() => {
            const callQueues = self.availableCallQueues().slice();

            const sorter = new SorterConstructor();
            sorter.sort(callQueues, "name", true);
            return callQueues;
        });

        // A caller sent to a queue waits there; the queue's own pools decide where they go next, so
        // there is nothing further to configure here.
        self.cancelForm = () => {
            return _promiseFactory.defer((deferredObject) => {
                _eventManager.publishRouteToCloseModal();
                deferredObject.resolve();
            });
        };

        self.detached = () => {
            _disposables.forEach(d => d.dispose());
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/common/routeToModal/facades/routeToCallQueueFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {
            _facade.getCallQueues()
                .done((callQueues) => {
                    self.availableCallQueues(callQueues);

                    if (initialRoutedToId !== null && initialRouteToType === _voiceRouteEnumerations.callQueue) {
                        self.selectedCallQueue(callQueues.find(callQueue => callQueue.id === initialRoutedToId));
                    } else {
                        // The option is only offered when the account has a queue, so there is
                        // always something to land on.
                        self.selectedCallQueue(self.callQueues()[0]);
                    }
                });

            return _promiseFactory.wait();
        };
    };
});

